import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Categoria } from 'src/app/model/categoria';
import { Cliente } from 'src/app/model/cliente';
import { DetallePedidoDTO } from 'src/app/model/detallePedidoDTO';
import { PedidoClienteDTO } from 'src/app/model/pedidoClienteDTO';
import { ProductosDTO } from 'src/app/model/productosDTO';
import { CategoriaService } from 'src/app/services/api/categoria.service';
import { PedidoService } from 'src/app/services/api/pedido.service';
import { PedidoDTOService } from 'src/app/services/api/pedidoDTO.service';
import { ProductoDTOService } from 'src/app/services/api/productoDTO.service';
import { TokenStorageServiceCliente } from 'src/app/services/api/TokenStorageServiceCliente';
import { db } from 'src/app/services/bd/bd';
import { environment } from 'src/environments/environment';



declare let $: any;

@Component({
  selector: 'app-cambio',
  templateUrl: './cambio.component.html',
  styleUrls: ['./cambio.component.css']
})
export class CambioComponent implements OnInit  {
  @ViewChild('myModal')
  myModal!: ElementRef;
  pedidoclienteDTO:PedidoClienteDTO[]=[];
  idCliente:number=0;
datoCliente:Cliente[]=[];
datoStorage:String="";
detallePedidoDTO:DetallePedidoDTO[]=[];
tipoMedia$ : String = "/0";
urlServerUpload$ : string = `${environment.HOST}/api/media/`;
idProductoOriginal:number=0;
idProductoCambio:number=0;
categoriadto:Categoria[]=[];
productosdto:ProductosDTO[]=[];
idCategoriaDTO:number=0;
precioAnteriorDTO:number=0;
idProductoAnteriorDTO:number=0;
indiceDetallePedidoDTO:number=0;
idPedidoDTO:number=0;
CantidadItem:String="";
formCambio1!: FormGroup;
modoBusqueda:boolean=false;
pedidoSeleccionado:boolean=false;
productoPorCambiar:boolean=false;
countpedido:String="0";
nombreCuenta:String="Mi cuenta";
tieneSession:boolean=false ;
idUsrDTO:number=0;
ocultarCarrito:boolean=false;
formBuscar!: FormGroup;
  constructor(
    private router:Router,
    private tokenStorage: TokenStorageServiceCliente,
    private pedidoService: PedidoService,
    private activatedRoute : ActivatedRoute,
    private detallePedidoDTOService : PedidoDTOService,
    private categoriaService : CategoriaService,
   private productoDTOService : ProductoDTOService
  ){
  
  
 

  
  
  }
  
  
  
  ngOnInit(){

    this.formBuscar = new FormGroup({
      'txtBuscar' : new FormControl('', Validators.required),
    });
    this.formCambio1 = new FormGroup({
      'cmbCategoria' : new FormControl('', Validators.required)
    });

    localStorage.setItem('modo_pedido_ls','0');
    
    this.OnContarPedido();

    if (localStorage.getItem('countPedido') !== null){
      this.countpedido=localStorage.getItem('countPedido')+"";
    }else {
      this.countpedido="0";
    }
    



    if (this.tokenStorage.getToken()==null) {
    
      this.router.navigateByUrl('/login-cliente/2');
  
  
    }else {
    
  
      if (this.tokenStorage.getToken()!==null) {
        let json = JSON.stringify(this.tokenStorage.getUser());
        let data=JSON.parse(json.toString());
        this.idUsrDTO=data.idUsuario;
        this.nombreCuenta=data.nombre
        this.tieneSession=true ;
          }
          const jsonObject =  JSON.parse( localStorage.getItem('cliente_stg')!);
          this.datoCliente=jsonObject;
          for (let lista of this.datoCliente){
          this.idCliente=lista.idCliente!;
          }
        


  this.OnGetPedidoDTOByCliente(this.idCliente);


  
  }
  
    

  window.scroll({ top: 0, left: 0, behavior: 'smooth' });




  }

  OnGetPedidoDTOByCliente(idCliente:number){
    this.pedidoService.getPedidoByCliente(idCliente).subscribe(response =>{
      console.log(response)
      return this.pedidoclienteDTO=response
    })
  }


  OnHabilitarBusqueda(){
    this.ocultarCarrito=true;
  }
  
  OnCerrarBusqueda(){
    this.ocultarCarrito=false;
  }
  



  OnBuscarAll(){

    this.modoBusqueda=true ;
    this.productosdto=[];
    
    this.productoDTOService.getProductosDTOByDescripcion(0,this.formBuscar.value['txtBuscar']).subscribe(response =>{
      console.log(response);
    
        return  this.productosdto=response;
      
    });
    }



OnRegresar(){

  this.pedidoSeleccionado=false;
  this.productoPorCambiar=false;
  this.OnGetPedidoDTOByCliente(this.idCliente);
  this.detallePedidoDTO=[];
 
}



OnProductoPorCambiar(_idProductoAnterior:any,_precioAnterior:any,_indice:any){
this.idProductoAnteriorDTO=_idProductoAnterior;
this.precioAnteriorDTO=_precioAnterior;
 this.productoPorCambiar=true;
this.indiceDetallePedidoDTO=_indice;
 this.OnGetCategoria();
 
}


  OnGetPedidoSelected(idPedido:number){
    this.pedidoService.getPedidoSelected(idPedido).subscribe(response =>{
      console.log(response)
      return this.pedidoclienteDTO=response

    });
    this.pedidoSeleccionado=true;
  }


  OnSeleccionaArticulo(idproducto:any,precioAnterior:any,indice:any){
this.precioAnteriorDTO=precioAnterior;
this.idProductoAnteriorDTO=idproducto;
this.indiceDetallePedidoDTO=indice;



    this.OnGetCategoria();
    
    }
    
    OnGetCategoria(){
      this.categoriaService.getCategoria().subscribe(response =>{
        console.log(response)
        return this.categoriadto=response
      })
    }

    OnSelectCategoria(){
      this.idCategoriaDTO=this.formCambio1.value['cmbCategoria'];
     // alert(this.idCategoriaDTO);
      this.getProductosDTO();
    }


  OnSelectPedido(idPedido:any){
this.idPedidoDTO=idPedido;
    this.OnGetDetallePedidoDTOById(this.idPedidoDTO,0);
this.OnGetPedidoSelected(this.idPedidoDTO);
    
  }

  OnGetDetallePedidoDTOById(idPedido:number,idEstado:number){
    this.detallePedidoDTOService.getDetallePedidoById(idPedido,idEstado).subscribe(response =>{
      console.log(response)
      return this.detallePedidoDTO=response
    })
  }
  
  getProductosDTO(){
        this.productoDTOService.getProductosDTO2( this.idCategoriaDTO).subscribe(response =>{
          console.log(response)
          return this.productosdto=response
        })
      }
    


      OnSelectProducto(idproducto:any){

      }

  OnGenerarDevolucion(){


  }


  OnSelectProductoNuevo(idproducto:any,_precionuevo:any){

    this.OnContarPedido();
 
    if (this.CantidadItem!=="0"){
      alert("¡Ya tiene un producto en el Carrito para Cambio!");
      this.router.navigate(['/carrito']);

    }else {


      if (_precionuevo >= this.precioAnteriorDTO){
        
       localStorage.setItem('modo_pedido_ls','1');
        this.router.navigate(['/pedido', idproducto,1,this.idPedidoDTO,this.idProductoAnteriorDTO,this.precioAnteriorDTO,this.indiceDetallePedidoDTO]);

      }else {
        alert("¡Este artículo es de menor precio, no es posible hacer el cambio!");
      }

     
    }

  }


  

  OnContarPedido(){
 
    this.ContarRegistros().then(data => {
     
     this.CantidadItem=data+""
  
    });
   
  }



 

    
    async ContarRegistros() {
 
      return await   db.detallePedidoBD.count();
      }
  
      logout(){
        this.tokenStorage.signOut();
        localStorage.removeItem('shopping');
    
        this.router.navigate(['/inicio'])
        .then(() => {
          window.location.reload();
        });
    
      }


}
